import { useMutation, useQueryClient } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import toastr from 'react-hot-toast'
import { generateURL } from 'utilities/hooks/urlGeneration'
import { SPARK_RESOURCE_TYPES } from 'constants/common'
import type {
  SingleCompanyOverviewResponse,
  CompanyOverviewAttribute,
} from 'types/CompanyOverview/companyOverview'

type MutationVariables = Partial<CompanyOverviewAttribute>

export const useAddCompanyOverview = () => {
  const queryClient = useQueryClient()
  const addCompanyOverview = (mutationVariables: MutationVariables) => {
    const body = {
      data: {
        type: SPARK_RESOURCE_TYPES.COMPANY_OVERVIEWS,
        attributes: mutationVariables,
      },
    }

    const url = generateURL(SPARK_RESOURCE_TYPES.COMPANY_OVERVIEWS)
    return fetchWrapper<SingleCompanyOverviewResponse>({
      url,
      method: 'POST',
      body,
    })
  }

  return useMutation('addCompanyOverview', addCompanyOverview, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Failed to add company overview: ${error.message}`)
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['workspace'])
    },
  })
}
